import React, { Component, useRef, useState } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import api from "../api-axios";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../UserInfo";
import notify from "devextreme/ui/notify";
import { LoadIndicator } from "devextreme-react/load-indicator";

const localStorageKey = "cadastroContribuinteGridState";

const CancelarEscrituracaoBox = () => {

    let _gridInstance = useRef();
    let _formInstance = useRef();

    const [cpfCnpj, setCpfCnpj] = useState("");
    const [mes, setMes] = useState();
    const [exercicio, setExercicio] = useState();
    const [notas, setNotas] = useState([]);
    const [msgCarregando, setMsgCarregando] = useState("");

    const carregarDados = async () => {
        setMsgCarregando("Buscando escriturações");

        var dadosRequisicao = {
            prefeituraId: UserInfo.getPrefeitura(),
            cpfCnpj,
            exercicio,
            mes: mes
        };

        try {
            var response = await api.post("/nfse/escrituracoes_cancelar", dadosRequisicao);
            setNotas(response.data);
            setMsgCarregando("");
        }
        catch (error) {
            notify(error, "error");
        }
        finally {
            setMsgCarregando("");
        }
    }

    const cancelarEscrituracao = async (e) => {

        setMsgCarregando("Cancelando Escrituração");

        var dadosRequisicao = {
            prefeituraId: UserInfo.getPrefeitura(),
            cefId: e.row.key
        };

        try {
            await api.post("/nfse/cancelar_escrituracao", dadosRequisicao);
            notify("Escrituração cancelada com sucesso.", "success");
        }
        catch (error) {
            notify(error, "error");
        }
        finally {
            setMsgCarregando("");
            carregarDados();
        }
    }

    const limparFiltro = () => {

        setMsgCarregando("Limpando filtros");
        setCpfCnpj("");
        setExercicio(null);
        setMes(null);
        setNotas([]);
        setMsgCarregando("");

    }



    if (msgCarregando != "") {
        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <div
                    style={{
                        display: "flex",
                        marginTop: "25px",
                        justifyContent: "center",
                        alignContent: "center",
                        justifyItems: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}
                >
                    <LoadIndicator width={60} height={60} />
                    <h3>{msgCarregando}</h3>
                </div>
            </div>
        );
    }


    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <h2 style={{ textAlign: "center" }}>CANCELAR ESCRITURAÇÃO</h2>
                <br />
                <form>
                    <Form id="frmPesquisa" colCount={9} ref={frm => _formInstance = frm}>
                        <SimpleItem name={"cpfCnpj"} colSpan={3} editorType={"dxTextBox"} editorOptions={{ value: cpfCnpj, onValueChanged: (e) => setCpfCnpj(e.value) }}>
                            <Label text="CPF/CNPJ" />
                        </SimpleItem>
                        <SimpleItem
                            editorType={"dxNumberBox"}
                            colSpan={2}
                            editorOptions={{ step: 0, value: exercicio, onValueChanged: (e) => setExercicio(e.value) }}
                        >
                            <Label text="Exercício" />
                        </SimpleItem>
                        <SimpleItem
                            editorType={"dxNumberBox"}
                            colSpan={2}
                            editorOptions={{ step: 0, value: mes, onValueChanged: (e) => setMes(e.value) }}
                        >
                            <Label text="Mês" />
                        </SimpleItem>

                        <ButtonItem buttonOptions={{ text: "Filtrar", type: "success", width: "100%", onClick: carregarDados }} />
                        <ButtonItem buttonOptions={{ text: "Limpar", width: "100%", onClick: limparFiltro }} />
                    </Form>
                </form>
                <br />
                <br />
                <h3> Lista de Escriturações</h3>
                <DataGrid
                    ref={(grid) => (_gridInstance = grid)}
                    dataSource={notas}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    remoteOperations={true}
                    columnAutoWidth={true}
                    focusedRowEnabled={true}
                    wordWrapEnabled={window.innerWidth < 800}
                    filterSyncEnabled={true}
                    keyExpr={"id"}
                    width={"100%"}>
                    <Column
                        type="buttons"
                        fixed={true}
                        fixedPosition={"left"}
                        buttons={[
                            "edit",
                            "delete",
                            {
                                hint: "Cancelar",
                                icon: "undo",
                                onClick: (e) => cancelarEscrituracao(e)
                            },
                        ]}
                    />
                    <Column
                        dataField={"id"}
                        allowEditing={false}
                        caption={"#"}
                        width={100}
                    >
                        <FormItem visibleIndex={1} />
                    </Column>


                    <Column dataField={"cv"} caption={"CV"} width={120} />


                    <Column
                        dataField={"ano"}
                        allowEditing={false}
                        caption={"Ano"}
                        width={100}
                        sortIndex={1}
                        sortOrder={"desc"}
                    />


                    <Column
                        dataField={"mes"}
                        allowEditing={false}
                        caption={"Mês"}
                        width={100}
                        sortIndex={1}
                        sortOrder={"desc"}
                        format={"00"}
                    />

                    <Column
                        dataField={"modalidade"}
                        allowEditing={false}
                        caption={"Modalidade"}
                    />

                    <Column dataField={"servicosPrestados"} caption={"Serv. Prestados (R$)"} width={180} format={uiInfo.formatoNumerico.n2} />
                    <Column dataField={"valorIss"} caption={"ISS (R$)"} width={180} format={uiInfo.formatoNumerico.n2} />

                    <Column
                        dataField={"damProprio"}
                        allowEditing={false}
                        caption={"DAM Próprio"}
                        width={120}
                    />

                    <Column
                        dataField={"semMovimento"}
                        allowEditing={false}
                        caption={"S/Movimento"}
                        width={120}
                    />

                    <Column
                        dataField={"prefeituraId"}
                        caption={"Prefeitura"}
                        visible={false}
                    />

                    <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

                    <Pager
                        showInfo={true}
                        showNavigationButtons={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                    />
                </DataGrid>
            </div>
        </React.Fragment>
    );


}

export default CancelarEscrituracaoBox;